export default __webpack_public_path__ + "static/media/P9LogoBlack.ff9ca553.png";